export default __webpack_public_path__ + "static/payment-d8059384339ea1cc22d7c645df7a6444.svg";